<!--
 * @Author: pengyong
 * @Date: 2020-12-02 23:09:36
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-14 21:24:57
 * @Description: 个人中心- 展品收藏
 * @FilePath: /exhibit/src/views/user/exhibitsCollect.vue
-->
<template>
    <div class="file-collect">
        <HeadLine
            showEdit
            :subTitle="$t('userCenter').edit"
            :count="checkIds.length"
            :isEdit="isEdit"
            @click-edit="clickEdit"
            @click-cancel="clickCancel"
            @click-del="clickDel"
            @click-all="clickAll"
        >
            <span v-if="!hideUserModalSideBar">
                {{ $t("userCenter").collectZp }}
            </span>
            <HeadLineTitle v-else />
        </HeadLine>
        <div class="items" v-if="!noData">
            <div class="item" v-for="item in lists" :key="item.id" @click="handleChoose(item)">
                <template v-if="isEdit">
                    <div class="box-bg"></div>
                    <div class="checked" v-if="checkIds.indexOf(item.id) > -1"></div>
                    <div class="unchecked" v-else></div>
                </template>
                <div class="img-box">
                    <img :src="item.product.cn.main_image[0].url" alt="" />
                </div>
                <div class="bot">{{ item.productName }}</div>
            </div>
        </div>
        <Empty v-else :text="$t('tips').noCollect" />
        <ProductDetail
            :id="id"
            :companyId="company_id"
            :exhibitionId="exhibition_id"
            :exhibition_productId="exhibition_product_id"
            v-if="id"
            @cancel="id = ''"
        />
    </div>
</template>

<script>
import api from "@/api";
import HeadLine from "./components/HeadLine";
// import { exhibition_id } from "@/utils/exhibitId";
import ProductDetail from "@/views/product/detail";
import HeadLineTitle from "./components/HeadLineTitle";
import { mapState } from "vuex";
import Empty from "@/components/Empty";
import { all_exhibition_id } from "../../utils/exhibitId"

export default {
    components: {
        ProductDetail,
        HeadLine,
        HeadLineTitle,
        Empty
    },
    data() {
        return {
            isEdit: false,
            lists: [],
            checkIds: [],
            id: "",
            company_id: "",
            exhibition_id: "",
            exhibition_product_id: "",
            noData: false
        };
    },
    computed: {
        ...mapState(["hideUserModalSideBar"])
    },
    mounted() {
        this.getMarkProduct();
    },
    methods: {
        getMarkProduct() {
            api.getMarkProduct({
                exhibition_id: all_exhibition_id
            }).then((res) => {
                if (res.res === 1) {
                    const lang = localStorage.getItem("language");
                    this.lists =
                        res.list.map((item) => {
                            return {
                                ...item,
                                productName: lang === "zh" ? item.product.cn.name : item.product.cn.name
                            };
                        }) || [];
                    console.log(this.lists)
                    this.noData = !this.lists.length;
                }
            });
        },
        handleChoose(item) {
            if (!this.isEdit) {
                console.log(item)
                this.id = item.id;
                this.company_id = Number(item.company.id);
                this.exhibition_id = item.exhibition.id
                this.exhibition_product_id = item.exhibition_product_id
                return;
            }
            let index = this.checkIds.indexOf(item.id);
            if (index === -1) {
                this.checkIds.push(item.id);
            } else {
                this.checkIds.splice(index, 1);
            }
        },
        clickEdit() {
            this.isEdit = true;
        },
        clickCancel() {
            this.isEdit = false;
        },
        clickDel() {
            if (!this.checkIds.length) return;
            let id = this.checkIds.join(",")
            console.log(this.checkIds.join(","))
            api.deleteMarkProduct(
                this.checkIds.join(",")
            ).then((res) => {
                if (res.res === 1) {
                    this.getMarkProduct();
                    this.isEdit = false;
                    this.checkIds = [];
                }
            });
        },
        clickAll(flag) {
            if (flag) {
                this.checkIds = this.lists.map((item) => item.id);
            } else {
                this.checkIds = [];
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixins.scss";
.file-collect {
    padding-top: 40px;
    font-size: 14px;
    height: 100%;
    box-sizing: border-box;

    .items {
        align-content:flex-start;
        margin-top: 36px;
        width: 95%;
        box-sizing: border-box;
        padding-right: 20px;
        height: calc(100% - 50px);
        overflow-y: scroll;
        display: flex;
        flex-wrap: wrap;
        /*定义滚动条高宽及背景*/
        &::-webkit-scrollbar {
            width: 1px;
        }
        /*定义滚动条*/
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 5px #fff;
            background: #fff;
        }
        /*定义滚动条轨道*/
        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 5px #fff;
            border-radius: 0;
            background: rgba(0, 0, 0, 0.1);
        }
        .item {
            height: 184px;
            width: 158px;
            margin-bottom: 13px;
            margin-right: 39px;
            position: relative;
            display: flex;
            align-items: flex-start;
            // border: 1px dashed #888;
            box-shadow: 2px 9px 26px rgba(34, 38, 56, 0.2);
            border-radius: 5px;
            border-radius: 8px;
            cursor: pointer;
            .img-box{
                width: 158px;
                height: 151px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 10px;
                img {
                    max-width: 100%;
                    max-height: 100%;
                    border-radius: 8px;
                }
            }
            
            .bot {
                @include textCutOff(1);
                font-weight: 500;
                font-size: 12px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #09468c;
                width: 100%;
                height: 33px;
                line-height: 33px;
                background: #ffffff;
                position: absolute;
                left: 0;
                bottom: 0;
                text-align: center;
                border-bottom-left-radius: 8px;
                border-bottom-right-radius: 8px;
            }
            .icon {
                width: 74px;
                height: 87px;
                margin-bottom: 15px;
            }
            .box-bg {
                // background: rgba(216, 216, 216, 0.7);
                position: absolute;
                width: 100%;
                bottom: 0;
                left: 0;
                right: 0;
                top: 0;
            }
            .checked {
                width: 15px;
                height: 15px;
                border-radius: 13px;
                position: absolute;
                left: 13px;
                top: 11px;
                z-index: 1;
                background: #ea6767 url("~@/assets/user/confirm.png") no-repeat center;
                background-size: contain;
            }
            .unchecked {
                width: 15px;
                height: 15px;
                border-radius: 13px;
                position: absolute;
                left: 13px;
                top: 11px;
                z-index: 1;
                border: 1px solid rgba(0, 0, 0, 0.45);
            }
        }
    }
    .items::-webkit-scrollbar {
        width: 8px;
        height: 100%;
        background-color: #fff;
    }
    .items::-webkit-scrollbar-thumb {
        width: 8px;
        height: 20%;
        background: #d8d8d8;
        border-radius: 4px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/user/exhibitsCollect.vue